import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from './notification.service';
import { trigger, style, animate, transition } from '@angular/animations';
import { Notification, NotificationMap } from './notification.model';
import { CommonUtil } from './../Utils/common-util';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ right: -460, opacity: 0 }),
        animate('300ms ease-out', style({ right: 0, opacity: 1 })),
      ]),
      transition(':leave', [
        style({ right: 0, opacity: 1 }),
        animate('300ms ease-in', style({ right: -460, opacity: 0 })),
      ]),
    ]),
  ],
})
export class NotificationComponent implements OnInit, OnDestroy {
  NTMap = NotificationMap;
  title: string = '';
  private sub = new Subscription();
  constructor(
    public notificationService: NotificationService,
    private _commonUtil: CommonUtil,
  ) {}

  ngOnInit(): void {
    this.notificationService.fetch();
  }

  populateText(item: Notification): string {
    let totalCount = 0;
    let message = '';
    if (!item?.length) {
      item.metadata = typeof item.metadata === 'object' ? item.metadata : JSON.parse(item?.metadata);
      if (item.notificationType === 'SET_LEVEL_CHANGED') {
        message = this._commonUtil.replaceValueAsHTMLOnTranslatedText(`NOTIFY.SET_LEVEL_CHANGED`, [
          item.metadata.parentFacilityName,
          item.metadata.childFacilityName,
        ]);
      } else if (item.notificationType === 'SET_LEVEL_INDEPENDENT') {
        message = this._commonUtil.replaceValueAsHTMLOnTranslatedText(`NOTIFY.SET_LEVEL_INDEPENDENT`, [
          item.metadata.facilityName,
        ]);
      }else if (item.notificationType === 'USER_ROLE_UPDATED') {
        message = this._commonUtil.replaceValueAsHTMLOnTranslatedText(`NOTIFY.USER_ROLE_UPDATED`, [
          item.metadata.firstName,
          item.metadata.facilityName,
        ]);
      } else {
        message = this._commonUtil.replaceValueAsHTMLOnTranslatedText(`NOTIFY.USER_ADDED`, [
          item.metadata.facilityName,
        ]);
      }
    } else {
      totalCount = item.length;
      message = this._commonUtil.replaceValueAsHTMLOnTranslatedText(`NOTIFY.${item[0].notificationType}`, [
        totalCount.toString(),
      ]);
    }
    return message;
  }

  getRecentTimeStamp(item: Notification[]): string {
    let recentDate: Date;
    if (item.length > 1) {
      recentDate = item.reduce((a: Notification, b: Notification) => {
        return a.updatedAt > b.updatedAt ? a : b;
      }).updatedAt;
    } else {
      recentDate = item[0].updatedAt;
    }
    return this._commonUtil.localizeDate(recentDate);
  }

  onClick(itemType: string, item: Notification | Notification[]) {
    let payloadIds = [];
    let payloadFacilityId = '';
    //TODO: Add amplitude analytics
    if (Array.isArray(item)) {
      let selectedIds = item.map((i: Notification) => (i.readStatus === 'UNREAD' ? i.id : ''));
      payloadIds = Object.assign([], selectedIds);
    } else {
      payloadIds.push(item?.id);
      payloadFacilityId = item.metadata?.facilityId;
    }
    this.notificationService.post(payloadIds, payloadFacilityId?.toString(), itemType);
  }

  markAllRead() {
    const notificationServiceSub = this.notificationService.updateStatus().subscribe(() => {
      this.notificationService.notifications$.next({});
      this.notificationService.count = 0;
    });
    this.sub.add(notificationServiceSub);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
